import { MnObject } from "backbone.marionette";

import { pazienHistory } from "common/components/pazienHistory";
import { _ } from "extensions/underscore";
    
import { View as TabsView, Model as TabsModel } from "common/components/tabs/";

export const TabController = MnObject.extend({
    _getMasterTabOptions() {
        const opts = _.resultPartial(this, "masterTabOptions");
        ["fragment", "view", "name"].forEach((prop) => {
            if (!opts[prop]) {
                throw new Error(`Missing '${prop}' in masterTabOptions`);
            }
        });
        
        return opts;
    },
    
    _getApplicationViewOptions() {
        const opts = _.resultPartial(this, "applicationViewOptions");
        ["id", "name"].forEach((prop) => {
            if (!opts[prop]) {
                throw new Error(`Missing '${prop}' in applicationViewOptions`);
            }
        });
        
        return opts;
    },
    
    layoutAlreadyDisplayingView(id) {
        const currentApplicationView = this.getParentChannel().request("get:app:view");
        
        if (currentApplicationView && currentApplicationView.model && currentApplicationView.model.id === id) {
            return currentApplicationView;
        }
    },
    
    _makeTabbedView(tabOptions, routerOptions, route) {
        const masterTab = { hideCloseIcon: true, id: "master", ...this._getMasterTabOptions() };
        const layoutModelData = { newTabButton: false, ...this._getApplicationViewOptions() };
        const tab = tabOptions.tab || masterTab;
    
        if (!tab.fragment) {
            tab.fragment = pazienHistory.getCurrentFragment();
        }
        
        // Return earlier if only need a view without any flow information how to render it
        if (routerOptions && routerOptions.viewOnly && tab) {
            let viewOptions = {};
            if (tabOptions.tab && _.isObject(tabOptions.tab.viewOptions)) {
                viewOptions = tabOptions.tab.viewOptions;
            }
        
            const View = tab.view;
            return new View(viewOptions);
        }
    
        let tabLayout = this.layoutAlreadyDisplayingView(layoutModelData.id);
        
        const activate = () => {
            const tabWithTheSameFragment = tabLayout.model.tabs.findWhere({ fragment: tab.fragment.split("?")[0] });
            if (tabWithTheSameFragment) {
                tabLayout.makeTabActive(tabWithTheSameFragment.id);
            } else {
                tabLayout.addTab(tab);
            }
        };
    
        // If current layout is already rendered then reuse it, otherwise create it
        if (!tabLayout) {
            // Otherwise create a new one with the master tab and then add the requested tab if it's not master
            const applicationViewModel = new TabsModel(layoutModelData);
            tabLayout = new TabsView({
                model: applicationViewModel,
                defaultTab: masterTab
            });
    
            // Append the layout into the view
            this.getParentChannel().request("show:app:view", tabLayout).then(activate);
        } else {
            activate();
        }
    }
});
